import React, { useContext, useState } from "react";
import { EditorContext } from "./EditorContext";
import { MaterialSelectorModal } from "./MaterialSelectorModal";
import "./MaterialSelector.scss";
import { Card } from "react-bootstrap";


export function MaterialSelector<T extends { id: number; sampleImageUrl: string | null; name: string}>(props: {
    materials: T[],
    currentId?: number,
    onSelect: ((mat: T) => void),
    header: string,
}) {

    const ec = useContext(EditorContext);

    const [showMaterialModal, setShowMaterialModal] = useState(false);

    function closeModal() {
        setShowMaterialModal(false);
    }
    function openModal() {
        setShowMaterialModal(true);
    }
    function selectMat(mat: T) {
        closeModal();
        props.onSelect(mat);
    }

    const currentMaterial = props.materials.find(m => m.id === props.currentId);
    const bgImage = currentMaterial?.sampleImageUrl ?? undefined;
    const matName = currentMaterial?.name
        ?? ec.translator("material-selector unknown name", "Vælg materiale");


    return (
        <>
            <Card onClick={openModal} style={{ cursor: "pointer", marginBottom: "16px" }} >
                {props.header && <Card.Header> {props.header} </Card.Header>}
                {bgImage && <Card.Img variant="top" src={bgImage} style={{height:"12em"}} />}
                <Card.Body>
                    <Card.Title>
                        {matName}
                    </Card.Title>
                </Card.Body>
            </Card>
            {showMaterialModal && (
                <MaterialSelectorModal
                    {...props}
                    onClose={closeModal}
                    onSelect={selectMat}
                />
            )}
        </>
    );
}
